var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-cluster"},[_vm._t("default"),_vm._l((_vm.categories),function(category){return _c('PatternCategory',{attrs:{"format":"cluster","category":category},on:{"select":function($event){return _vm.$emit('select', category)}}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }